'use client';
const experimental_options = {
  noSlot: false
};

export { experimental_options };
